import { render, staticRenderFns } from "./ShopifyIntegration.pug?vue&type=template&id=95e5c130&lang=pug&external"
import script from "./ShopifyIntegration.js?vue&type=script&lang=js&external"
export * from "./ShopifyIntegration.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports